{
  "appPoweredBy": "pinapagana ng {name}",
  "loading": "Naglo-load…",
  "save": "I-save",
  "saving": "Sine-save…",
  "saved": "Na-save",
  "cancel": "Kanselahin",
  "close": "Isara",
  "back": "Bumalik",
  "next": "Susunod",
  "edit": "I-edit",
  "delete": "Burahin",
  "remove": "Alisin",
  "add": "Idagdag",
  "search": "Maghanap",
  "filter": "Salain",
  "filters": "Mga filter",
  "clear": "I-clear",
  "retry": "Subukang muli",
  "submit": "Isumite",
  "send": "Ipadala",
  "yes": "Oo",
  "no": "Hindi",
  "unknown": "Hindi sigurado",
  "optional": "opsyonal",
  "required": "kailangan",
  "seeAll": "Tingnan lahat",
  "loadMore": "Magpakita pa",
  "share": "Ibahagi",
  "copied": "Nakopya ang link",
  "offline": "Offline ka. Ipinapakita ang naka-save na impormasyon.",
  "offlineShort": "Offline",
  "backOnline": "Online na ulit",
  "savedWillSend": "Na-save — ipapadala kapag may koneksyon na",
  "pendingSend": "{count} naghihintay maipadala",
  "lastUpdated": "Huling in-update ng {office} noong {date}",
  "updatedOn": "In-update noong {date}",
  "call911": "Tumawag sa 911",
  "emergency": "Emergency",
  "reportEmergency": "Mag-ulat ng emergency",
  "verified": "Beripikadong opisina ng LGU",
  "townWide": "Buong bayan",
  "barangay": "Barangay",
  "allBarangays": "Lahat ng barangay",
  "chooseBarangay": "Piliin ang iyong barangay",
  "signIn": "Mag-sign in",
  "signOut": "Mag-sign out",
  "signUp": "Gumawa ng account",
  "notFound": "Hindi namin mahanap ang pahinang iyon.",
  "goHome": "Pumunta sa home",
  "errorTitle": "May nangyaring mali",
  "privacyNotice": "Abiso sa privacy",
  "consentDefault": "Pumapayag ako na kolektahin at gamitin ng LGU ang impormasyong ito para sa layuning ito, ayon sa abiso sa privacy (Data Privacy Act of 2012, RA 10173).",
  "consentLocation": "Kinokolekta ng form na ito ang iyong lokasyon, mga larawan at contact details. Gagamitin lamang ito ng LGU para tumugon sa ulat na ito, sa ilalim ng Data Privacy Act of 2012 (RA 10173). Ang lokasyon ay naka-save lamang kasama ng ulat na ito; hindi ka namin sinusubaybayan.",
  "readPrivacy": "Basahin ang abiso sa privacy",
  "photos": "Mga larawan",
  "addPhoto": "Magdagdag ng larawan",
  "takePhoto": "Kumuha o pumili ng larawan",
  "removePhoto": "Alisin ang larawan",
  "useMyLocation": "Gamitin ang aking lokasyon",
  "locating": "Hinahanap ang iyong lokasyon…",
  "locationDenied": "Naka-off ang lokasyon. Piliin na lang ang iyong barangay.",
  "today": "Ngayon",
  "tomorrow": "Bukas",
  "thisWeek": "Ngayong linggo",
  "all": "Lahat",
  "none": "Wala",
  "status": "Katayuan",
  "details": "Detalye",
  "name": "Pangalan",
  "mobile": "Numero ng mobile",
  "email": "Email",
  "password": "Password",
  "landmark": "Palatandaan",
  "notes": "Mga tala",
  "description": "Paglalarawan",
  "date": "Petsa",
  "time": "Oras",
  "from": "Mula",
  "to": "Hanggang",
  "export": "I-export",
  "print": "I-print",
  "download": "I-download",
  "open": "Buksan",
  "view": "Tingnan",
  "new": "Bago"
}
